module.exports = __webpack_public_path__ + "static/media/20201121_224946_871_IMG_1085.2a88c704.jpg";